import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FeatureService, Gateway, GatewayStore } from '@store';

import { Observable } from 'rxjs';

@Component({
  selector: 'app-nbiot',
  templateUrl: './nbiot.component.html',
  styleUrls: ['./nbiot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbiotComponent implements OnInit {
  gateway$: Observable<Gateway>;
  gatewayType$: Observable<string>;

  constructor(
    private featureService: FeatureService,
    public translateService: TranslateService,
    protected gatewayStore: GatewayStore
  ) {}

  ngOnInit(): void {
    this.gateway$ = this.featureService.selectGatewayProperties();
    this.gatewayType$ = this.gatewayStore.getGatewayType();
  }
}
